import { render, staticRenderFns } from "./footerBar.vue?vue&type=template&id=7caf038a&scoped=true&"
import script from "./footerBar.vue?vue&type=script&lang=js&"
export * from "./footerBar.vue?vue&type=script&lang=js&"
import style0 from "./footerBar.vue?vue&type=style&index=0&id=7caf038a&prod&scoped=true&lang=css&"
import style1 from "./footerBar.vue?vue&type=style&index=1&id=7caf038a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf038a",
  null
  
)

export default component.exports